import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-error-page',
  imports: [RouterLink],
  template: `
    <main>
      <h1>Error</h1>
      <p>This is a placeholder error page.</p>
      <nav><a routerLink="/sign-in">Go to sign in</a></nav>
    </main>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/** Placeholder for generic application errors. */
export class ErrorComponent {}
